module.exports = __webpack_public_path__ + "static/img/circel_03_m.0b6f35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circel_03_m.png
// module id = rxvN
// module chunks = 1